// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1NWys","selected":"Chip_selected__3EZXX"};